/**
 * Asset category configuration - controls which fields/tabs/labels
 * are visible based on the asset type's category.
 */
export const categoryConfig = {
    vehicle: {
        personLabel: 'Driver',
        personIcon: 'mdi-card-account-details',
        showVin: true,
        showMakeModelYear: true,
        showOdometer: true,
        showFuel: true,
        showDtc: true,
        showFuelTab: true,
        showDtcTab: true,
        showHealthTab: true,
    },
    equipment: {
        personLabel: 'Operator',
        personIcon: 'mdi-account-hard-hat',
        showVin: true,
        showMakeModelYear: true,
        showOdometer: true,
        showFuel: true,
        showDtc: false,
        showFuelTab: true,
        showDtcTab: false,
        showHealthTab: true,
    },
    personal: {
        personLabel: 'Carrier',
        personIcon: 'mdi-account',
        showVin: false,
        showMakeModelYear: false,
        showOdometer: false,
        showFuel: false,
        showDtc: false,
        showFuelTab: false,
        showDtcTab: false,
        showHealthTab: false,
    },
    livestock: {
        personLabel: 'Handler',
        personIcon: 'mdi-account',
        showVin: false,
        showMakeModelYear: false,
        showOdometer: false,
        showFuel: false,
        showDtc: false,
        showFuelTab: false,
        showDtcTab: false,
        showHealthTab: false,
    },
    'location-anchor': {
        personLabel: null,
        personIcon: null,
        showVin: false,
        showMakeModelYear: false,
        showOdometer: false,
        showFuel: false,
        showDtc: false,
        showFuelTab: false,
        showDtcTab: false,
        showHealthTab: false,
    },
    building: {
        personLabel: null,
        personIcon: null,
        showVin: false,
        showMakeModelYear: false,
        showOdometer: false,
        showFuel: false,
        showDtc: false,
        showFuelTab: false,
        showDtcTab: false,
        showHealthTab: false,
    },
};

const defaultConfig = {
    personLabel: 'Assigned Person',
    personIcon: 'mdi-account',
    showVin: false,
    showMakeModelYear: false,
    showOdometer: false,
    showFuel: false,
    showDtc: false,
    showFuelTab: false,
    showDtcTab: false,
    showHealthTab: false,
};

export const getCategoryConfig = (category) => {
    if (!category) return defaultConfig;
    return categoryConfig[category] || defaultConfig;
};

export const assetCategories = [
    {value: 'vehicle', title: 'Vehicle'},
    {value: 'equipment', title: 'Equipment'},
    {value: 'personal', title: 'Personal'},
    {value: 'livestock', title: 'Livestock'},
    {value: 'location-anchor', title: 'Location Anchor'},
    {value: 'building', title: 'Building'},
];
